export default __webpack_public_path__ + "static/error-2fce6214b7c60c745aa619c230fe779b.png";